/*
 * @Author: 朱亚
 * @Date: 2020-10-10 10:19:09
 * @说明：用户(account)相关的所有接口地址定义
 */
// 获取用户可登录的门店
export const getUserStore = '/account/login/get-user-store'
// 用户的登录地址
export const doLogin = '/account/login/do-login'
// 手机验证码登录获取手机验证码
export const getPhoneLoginVerify = '/account/login/get-phone-login-verify'
// 获取微信第三方登录url
export const accountUnionLoginUrl = '/account/login/union-login-url'
// 获取微信第三方登录url
export const accountRegisterUrl = '/account/login/register-url'
// 运营授权登录
export const signLogin = '/account/login/sign-login'
// erp扫码登录
export const qrLogin = '/account/login/qr-login'
// 获取登录网址
export const getDomain = '/account/login/get-domain'
// 退出登录
export const logout = '/account/login/logout'
// 首页 start
// 首页所需要的数据都都过此接口获取
export const homeInfo = '/index/index/index'
export const storeAnalyse = '/index/index/get-store-analyse'
export const saveAnalyse = '/index/index/save-analyse'
export const outputLine = '/index/index/get-output-line'
// 首页 end
// 集团首页 start
// 集团首页所需要的数据都都过此接口获取
export const groupHomeInfo = '/index/index/cockpit'
export const yearIncomeStatistics = '/index/index/year-income-statistics'
export const settlementStaticsList = '/index/index/settlement-statics-list'
export const orderOutsourcingStaticsList = '/index/index/order-outsourcing-statics-list'
export const customerRankStatistics = '/index/index/customer-rank-statistics'
export const settlementMethodStatistics = '/index/index/settlement-method-statistics'
export const yearIncomeContrastStatistics = '/index/index/year-income-contrast-statistics'
export const customerStaticsList = '/index/index/customer-statics-list'
// 集团首页 end
// 个人中心 start
// 系统-获取服务功能列表
export const functionService = '/account/application/get-service-function'
// 系统-功能服务查看详情
export const functionServiceUrl = '/account/application/get-url'
// 系统-进入应用中心数据
export const functionDetail = '/account/application/detail'
// 员工个人中心
export const accountHome = '/account/account-center/get-user-main'
// 员工个人中心-修改密码
export const updateAccountPassword = '/account/account-center/update-password'
// 员工个人中心-获取基本信息
export const getAccountBase = '/account/account-center/get-base-info'
// 员工个人中心-修改基本信息
export const updateAccountBase = '/account/account-center/update-base-info'
// 系统-获取门店套餐
export const getPackageInfo = '/account/account-center/get-package-info'
// 系统-修改手机获取验证码
export const getPhoneVerify = '/account/account-center/phone-verify'
// 系统-修改手机
export const updatePhone = '/account/account-center/update-phone'
// 个人中心 end
// 系统-获取门店套餐到期提示
export const packageNotice = '/index/index/package-notice'
// 系统-获取门店信息
export const storeInfo = '/account/account-center/store-info'
// 系统-保存门店信息
export const saveStore = '/account/account-center/save-store'
// 系统-获取城市地址
export const regionList = '/account/account-center/get-region-list'
// 系统-切换门店
export const switchStore = '/account/account-center/switch-store'



// WEBPACK FOOTER //
// ./src/api/url/account.js